module.exports = __webpack_public_path__ + "static/4-9b2370001a329e6b0e9be0ed92b50ec2.jpg";